var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"header-container"},[_c('h1',{staticClass:"pageTitle"},[_vm._v(_vm._s(_vm.title))]),_vm._t("optionalElement")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }